<script lang="ts">
	import { onMount } from 'svelte';
	import { appStore } from '../stores/appStore';
	import { getTokenStorage } from '../utils/localStorage';
	import  { AppApiClient } from '../api_contracts/app.client';
	import Navbar from '../components/Navbar.svelte';
    import ActivityGraph from '../components/ActivityGraph.svelte';
  import { PublicUserProfile, RepositoryInfo } from '../api_contracts/app';
  import PublicRecentActivity from './PublicRecentActivity.svelte';
//   import { UserProfile } from '../api_contracts/app';
    // import  { RepositoryListData , UserProfile} from '../models/state';


	// State
	let client: AppApiClient | null = $state(null);
	let token: string = $state('');
	let username = $state('');
	let loading = $state(true);
	let error = $state('');
	let activeTab = $state('overview'); // 'overview', 'repositories', 'projects', 'packages'

	let profile: PublicUserProfile = $state({
		username: '',
		firstName: '',
		lastName: '',
		bio: '',
		location: '',
		email: '',
		website: '',
		avatarUrl: '',
		repositoryCount: 0,
		starredCount: 0,
		followersCount: 0,
		followingCount: 0
	});

	let repositories: RepositoryInfo[] = $state([]);
	let pinnedRepos: RepositoryInfo[] = $state([]);
	let starredRepos: RepositoryInfo[] = $state([]);
	let starredLoading = $state(false);
	let isFollowing = $state(false);
	let isFollowLoading = $state(false);
	let isCurrentUser = $state(false);
	let commitData: Array<{date: string, count: number}> = $state([]);
	let totalCommits = $state(0);

	// Social links and emails
	interface SocialLink {
		id: string;
		platform: string;
		url: string;
		displayOrder: number;
	}
	let socialLinks: SocialLink[] = $state([]);
	let publicEmails: string[] = $state([]);

	// Subscribe to store
	appStore.subscribe(state => {
		client = state.client;
		token = state.token;
	});

	// Helper to get initials from name
	function getInitials(firstName: string, lastName: string): string {
		const first = firstName?.charAt(0) || '';
		const last = lastName?.charAt(0) || '';
		return (first + last).toUpperCase() || 'U';
	}

	// Helper to get platform icon SVG
	function getPlatformIcon(platform: string): string {
		const icons: { [key: string]: string } = {
			github: '<path fill="currentColor" d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>',
			twitter: '<path fill="currentColor" d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>',
			linkedin: '<path fill="currentColor" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>',
			facebook: '<path fill="currentColor" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>',
			instagram: '<path fill="currentColor" d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>',
			youtube: '<path fill="currentColor" d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>',
			tiktok: '<path fill="currentColor" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>',
			reddit: '<path fill="currentColor" d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>',
			medium: '<path fill="currentColor" d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/>',
			dev: '<path fill="currentColor" d="M7.42 10.05c-.18-.16-.46-.23-.84-.23H6l.02 2.44.04 2.45.56-.02c.41 0 .63-.07.83-.26.24-.24.26-.36.26-2.2 0-1.91-.02-1.96-.29-2.18zM0 4.94v14.12h24V4.94H0zM8.56 15.3c-.44.58-1.06.77-2.53.77H4.71V8.53h1.4c1.67 0 2.16.18 2.6.9.27.43.29.6.32 2.57.05 2.23-.02 2.73-.47 3.3zm5.09-5.47h-2.47v1.77h1.52v1.28l-.72.04-.75.03v1.77l1.22.03 1.2.04v1.28h-1.6c-1.53 0-1.6-.01-1.87-.3l-.3-.28v-3.16c0-3.02.01-3.18.25-3.48.23-.31.25-.31 1.88-.31h1.64v1.3zm4.68 5.45c-.17.43-.64.79-1 .79-.18 0-.45-.15-.67-.39-.32-.32-.45-.63-.82-2.08l-.9-3.39-.45-1.67h.76c.4 0 .75.02.75.05 0 .06 1.16 4.54 1.26 4.83.04.15.32-.7.73-2.3l.66-2.52.74-.04c.4-.02.73 0 .73.04 0 .14-1.67 6.38-1.8 6.68z"/>',
			stackoverflow: '<path fill="currentColor" d="M15.725 0l-1.72 1.277 6.39 8.588 1.716-1.277L15.725 0zm-3.94 3.418l-1.369 1.644 8.225 6.85 1.369-1.644-8.225-6.85zm-3.15 4.465l-.905 1.94 9.702 4.517.904-1.94-9.701-4.517zm-1.85 4.86l-.44 2.093 10.473 2.201.44-2.092-10.473-2.203zM1.89 15.47V24h19.19v-8.53h-2.133v6.397H4.021v-6.396H1.89zm4.265 2.133v2.13h10.66v-2.13H6.154Z"/>',
			dribbble: '<path fill="currentColor" d="M12 24C5.385 24 0 18.615 0 12S5.385 0 12 0s12 5.385 12 12-5.385 12-12 12zm10.12-10.358c-.35-.11-3.17-.953-6.384-.438 1.34 3.684 1.887 6.684 1.992 7.308 2.3-1.555 3.936-4.02 4.395-6.87zm-6.115 7.808c-.153-.9-.75-4.032-2.19-7.77l-.066.02c-5.79 2.015-7.86 6.025-8.04 6.4 1.73 1.358 3.92 2.166 6.29 2.166 1.42 0 2.77-.29 4-.814zm-11.62-2.58c.232-.4 3.045-5.055 8.332-6.765.135-.045.27-.084.405-.12-.26-.585-.54-1.167-.832-1.74C7.17 11.775 2.206 11.71 1.756 11.7l-.004.312c0 2.633.998 5.037 2.634 6.855zm-2.42-8.955c.46.008 4.683.026 9.477-1.248-1.698-3.018-3.53-5.558-3.8-5.928-2.868 1.35-5.01 3.99-5.676 7.17zM9.6 2.052c.282.38 2.145 2.914 3.822 6 3.645-1.365 5.19-3.44 5.373-3.702-1.81-1.61-4.19-2.586-6.795-2.586-.825 0-1.63.1-2.4.285zm10.335 3.483c-.218.29-1.935 2.493-5.724 4.04.24.49.47.985.68 1.486.08.18.15.36.22.53 3.41-.43 6.8.26 7.14.33-.02-2.42-.88-4.64-2.31-6.38z"/>',
			behance: '<path fill="currentColor" d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.767-.61.165-1.252.25-1.91.25H0V4.5h6.938zM3.495 11.12h3.08c.718 0 1.27-.14 1.66-.42.39-.28.585-.76.585-1.44 0-.44-.096-.8-.29-1.07-.19-.27-.44-.48-.73-.64-.29-.15-.62-.25-.96-.3-.34-.04-.66-.06-.98-.06H3.495v3.93zm0 7.42h3.23c.38 0 .74-.03 1.1-.1.36-.07.68-.19.98-.37.29-.18.52-.42.68-.73.16-.31.23-.68.23-1.12 0-.85-.23-1.45-.7-1.8-.47-.35-1.11-.53-1.92-.53H3.495v4.65zM21.5 27V9h6.9v1.8h-4.2v5.1h4.2v1.8h-4.2V27h-2.7zm-1.8-14.1h8.1v-2.7h-8.1v2.7z"/>',
			twitch: '<path fill="currentColor" d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>',
			discord: '<path fill="currentColor" d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>',
			website: '<path fill="currentColor" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>'
		};
		return icons[platform.toLowerCase()] || icons.website;
	}

	async function fetchUserProfile() {
		if (!client || !username) {
			error = 'Client not initialized or username not provided';
			loading = false;
			return;
		}

		try {
			loading = true;
			error = '';

			const responseData = await client.getPublicUserProfile({
				username: username,
				token: token || '' // Pass token if available, so owner can see private repos
			});

			if (responseData.response?.response.successFull ) {
				profile = responseData.response?.profile;

				// Convert repositories to the format expected by the UI
				if (responseData.response?.repositories && responseData.response?.repositories.length > 0) {
                   repositories= responseData.response?.repositories
					// repositories = responseData.response?.repositories.map((repo) => {
					// 	// Calculate relative time for updatedAt
					// 	const updatedAt = repo.updatedAt?.seconds
					// 		? getRelativeTime(new Date(Number(repo.updatedAt.seconds) * 1000))
					// 		: 'Unknown';

					// 	return {
					// 		name: repo.name || '',
					// 		description: repo.description || '',
					// 		visibility: repo.visibility || 'public',
					// 		language: repo.primaryLanguage || '',
					// 		languageColor: repo.primaryLanguageColor || '#cccccc',
					// 		stars: repo.starCount || 0,
					// 		forks: repo.forkCount || 0,
					// 		updatedAt: updatedAt
					// 	};
					// });

					// Sort by stars for pinned repos (top 6)
					pinnedRepos = [...repositories].sort((a, b) => b.starCount - a.starCount).slice(0, 6);
				} else {
					repositories = [];
					pinnedRepos = [];
				}
			} else {
				error = responseData.response?.response.reason || 'Failed to load profile';
			}
		} catch (e: any) {
			error = e.message || 'Error loading profile';
			console.error('Error fetching user profile:', e);
		} finally {
			loading = false;
		}
	}

	// Helper function to convert timestamp to relative time
	function getRelativeTime(date: Date): string {
		const now = new Date();
		const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

		if (diffInSeconds < 60) return 'just now';
		if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
		if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
		if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`;
		if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 604800)} weeks ago`;
		if (diffInSeconds < 31536000) return `${Math.floor(diffInSeconds / 2592000)} months ago`;
		return `${Math.floor(diffInSeconds / 31536000)} years ago`;
	}

	async function fetchStarredRepositories() {
		if (!client || !username || starredRepos.length > 0) {
			return; // Already loaded or can't load
		}

		try {
			starredLoading = true;
			const responseData = await client.getStarredRepositories({
				username: username
			});

			if (responseData.response?.successFull && responseData.response?.repositories) {
				starredRepos = responseData.response.repositories;
			} else {
				console.error('Failed to load starred repositories:', responseData.response?.reason);
				starredRepos = [];
			}
		} catch (e: any) {
			console.error('Error fetching starred repositories:', e);
			starredRepos = [];
		} finally {
			starredLoading = false;
		}
	}

	async function fetchSocialLinks() {
		if (!client || !username) return;

		try {
			const responseData = await client.getPublicSocialLinks({
				username: username
			});

			if (responseData.response?.successFull && responseData.response?.links) {
				socialLinks = responseData.response.links.map((link: any) => ({
					id: link.id,
					platform: link.platform,
					url: link.url,
					displayOrder: link.displayOrder
				}));
			} else {
				socialLinks = [];
			}
		} catch (e: any) {
			console.error('Error fetching social links:', e);
			socialLinks = [];
		}
	}

	async function fetchPublicEmails() {
		if (!client || !username) return;

		try {
			const responseData = await client.getPublicEmails({
				username: username
			});

			if (responseData.response?.successFull && responseData.response?.emails) {
				publicEmails = responseData.response.emails;
			} else {
				publicEmails = [];
			}
		} catch (e: any) {
			console.error('Error fetching public emails:', e);
			publicEmails = [];
		}
	}

	async function fetchCommitActivity() {
		if (!client || !username) return;

		try {
			// Calculate date range (last 365 days)
			const endDate = new Date();
			const startDate = new Date();
			startDate.setFullYear(endDate.getFullYear() - 1);

			const startDateStr = startDate.toISOString().split('T')[0];
			const endDateStr = endDate.toISOString().split('T')[0];

			const responseData = await client.getUserCommitActivity({
				username: username,
				startDate: startDateStr,
				endDate: endDateStr
			});

			if (responseData.response?.successFull && responseData.response?.days) {
				commitData = responseData.response.days.map(day => ({
					date: day.date,
					count: day.count
				}));
				totalCommits = responseData.response.totalCommits || 0;
			} else {
				commitData = [];
				totalCommits = 0;
			}
		} catch (e: any) {
			console.error('Error fetching commit activity:', e);
			commitData = [];
			totalCommits = 0;
		}
	}

	function handleTabChange(tab: string) {
		activeTab = tab;
		if (tab === 'stars' && starredRepos.length === 0 && !starredLoading) {
			fetchStarredRepositories();
		}
	}

	async function checkIfFollowing() {
		if (!client || !username || !token) {
			return;
		}

		try {
			const responseData = await client.isFollowing({
				token: token,
				username: username
			});

			if (responseData.response?.successFull) {
				isFollowing = responseData.response.isFollowing || false;
			}
		} catch (e: any) {
			console.error('Error checking follow status:', e);
		}
	}

	async function toggleFollow() {
		if (!client || !username || !token) {
			error = 'You must be logged in to follow users';
			return;
		}

		try {
			isFollowLoading = true;

			if (isFollowing) {
				const responseData = await client.unfollowUser({
					token: token,
					username: username
				});

				if (responseData.response?.successFull) {
					isFollowing = false;
					profile.followersCount = Math.max(0, profile.followersCount - 1);
				} else {
					error = responseData.response?.reason || 'Failed to unfollow user';
				}
			} else {
				const responseData = await client.followUser({
					token: token,
					username: username
				});

				if (responseData.response?.successFull) {
					isFollowing = true;
					profile.followersCount = profile.followersCount + 1;
				} else {
					error = responseData.response?.reason || 'Failed to follow user';
				}
			}
		} catch (e: any) {
			error = e.message || 'Error toggling follow';
			console.error('Error toggling follow:', e);
		} finally {
			isFollowLoading = false;
		}
	}

	onMount(async () => {
		const hash = window.location.hash;
		const match = hash.match(/\/users\/([^\/]+)/);
		if (match) {
			username = match[1];
		}
		await fetchUserProfile();
		await fetchSocialLinks();
		await fetchPublicEmails();
		await fetchCommitActivity();

		// Check if this is the current user's profile
		if (client && token) {
			try {
				const profileResponse = await client.getUserProfile({ token });
				if (profileResponse.response?.response.successFull && profileResponse.response.profile) {
					isCurrentUser = profileResponse.response.profile.userName === username;
				}
			} catch (e) {
				console.error('Error getting current user profile:', e);
			}

			// Check if following (only if not current user)
			if (!isCurrentUser) {
				checkIfFollowing();
			}
		}
	});
</script>

<Navbar />

<div class="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
	<!-- Sub-navigation for Profile Sections (Overview, Repos, etc) -->
    <div class="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 sticky top-0 z-10 pt-4">
        <div class="container mx-auto px-4 max-w-7xl flex gap-8 overflow-x-auto">
             <!-- Placeholder for spacing to align with content -->
             <div class="hidden md:block w-1/4 lg:w-1/5"></div>
             
             <nav class="flex space-x-1">
                 <button
                    onclick={() => handleTabChange('overview')}
                    class="px-4 py-2 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 whitespace-nowrap {activeTab === 'overview' ? 'border-brand-500 text-gray-900 dark:text-white' : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 hover:border-gray-300'}"
                 >
                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                    Overview
                 </button>
                 <button
                    onclick={() => handleTabChange('repositories')}
                    class="px-4 py-2 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 whitespace-nowrap {activeTab === 'repositories' ? 'border-brand-500 text-gray-900 dark:text-white' : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 hover:border-gray-300'}"
                 >
                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" /></svg>
                    Repositories
                    <span class="bg-gray-200 dark:bg-gray-700 text-xs rounded-full px-2 py-0.5">{profile.repositoryCount}</span>
                 </button>
                 <button
                    onclick={() => handleTabChange('stars')}
                    class="px-4 py-2 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 whitespace-nowrap {activeTab === 'stars' ? 'border-brand-500 text-gray-900 dark:text-white' : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 hover:border-gray-300'}"
                 >
                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                    Stars
                    <span class="bg-gray-200 dark:bg-gray-700 text-xs rounded-full px-2 py-0.5">{profile.starredCount}</span>
                 </button>
             </nav>
        </div>
    </div>

	<div class="container mx-auto px-4 py-8 max-w-7xl">
		{#if loading}
			<div class="flex justify-center items-center h-64">
				<div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
			</div>
		{:else if error}
			<div class="text-center text-red-500 py-10">
				<p>{error}</p>
			</div>
		{:else}
            <div class="flex flex-col md:flex-row gap-8">
                
                <!-- Sidebar (Profile Info) -->
                <aside class="w-full md:w-1/4 lg:w-1/5 -mt-16 md:-mt-0">
                    <div class="md:sticky md:top-24 space-y-6">
                        <!-- Avatar -->
                         <div class="relative group">
                            {#if profile.avatarUrl}
                                <img
                                    src={profile.avatarUrl}
                                    alt={profile.username}
                                    class="w-32 h-32 md:w-64 md:h-64 rounded-full border-4 border-white dark:border-gray-900 shadow-md mx-auto md:mx-0"
                                />
                            {:else}
                                <!-- <div class="w-32 h-32 md:w-full md:aspect-square rounded-full border-4 border-white dark:border-gray-900 shadow-md bg-gradient-to-br from-orange-400 to-pink-500 flex items-center justify-center text-white text-4xl md:text-7xl font-bold mx-auto md:mx-0"> -->
                                <div
									class="w-32 h-32 rounded-full bg-brand-500 dark:bg-brand-600 flex items-center justify-center text-white text-lg font-semibold"
								>   
                                {getInitials(profile.firstName, profile.lastName)}
                                </div>
                            {/if}
                            <!-- Status Indicator (Mock) -->
                             <!-- <div class="absolute bottom-4 right-4 md:bottom-8 md:right-8 w-8 h-8 bg-white dark:bg-gray-900 rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-700 shadow-sm cursor-pointer hover:text-brand-500">
                                <span class="text-lg">🎯</span>
                             </div> -->
                        </div>

                        <!-- Names -->
                        <div class="text-center md:text-left">
                            <h1 class="text-2xl font-bold text-gray-900 dark:text-white leading-tight">
                                {profile.firstName} {profile.lastName}
                            </h1>
                            <p class="text-xl text-gray-500 dark:text-gray-400 font-light">
                                {profile.username}
                            </p>
                        </div>

                        <!-- Bio -->
                        {#if profile.bio}
                            <div class="text-gray-800 dark:text-gray-300 text-base">
                                {profile.bio}
                            </div>
                        {/if}

                        <!-- Actions -->
                        <div class="w-full">
                            {#if !isCurrentUser}
                                <button
                                    onclick={toggleFollow}
                                    disabled={isFollowLoading}
                                    class="w-full py-1.5 px-4 {isFollowing ? 'bg-gray-100 hover:bg-gray-200 text-gray-900 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white' : 'bg-brand-500 hover:bg-brand-600 text-white'} border border-gray-300 dark:border-gray-600 rounded-md font-medium text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                                >
                                    {#if isFollowLoading}
                                        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
                                    {/if}
                                    {isFollowing ? 'Unfollow' : 'Follow'}
                                </button>
                            {:else}
                                <button
                                    class="w-full py-1.5 px-4 bg-gray-100 hover:bg-gray-200 text-gray-900 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md font-medium text-sm transition-colors"
                                    onclick={()=>{
                                        
                                          window.location.hash = `/profile`
                                    
                                    }}
                                >
                                    Edit Profile
                                </button>
                            {/if}
                             <div class="mt-2 text-xs text-gray-500">
                                <span class="font-bold text-gray-900 dark:text-white hover:text-brand-500 cursor-pointer">{profile.followersCount}</span> followers ·
                                <span class="font-bold text-gray-900 dark:text-white hover:text-brand-500 cursor-pointer">{profile.followingCount}</span> following
                            </div>
                        </div>

                        <!-- Details -->
                        <div class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                             {#if profile.location}
                                <div class="flex items-center gap-2">
                                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    <span>{profile.location}</span>
                                </div>
                             {/if}
                             <!-- <div class="flex items-center gap-2">
                                <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                                <a href="mailto:{profile.email}" class="hover:text-brand-500 hover:underline">{profile.email}</a>
                            </div> -->

                            <!-- Public Emails -->
                             {#if publicEmails.length > 0}
                                 {#each publicEmails as email}
                                     <div class="flex items-center gap-2">
                                         <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                         </svg>
                                         <a href="mailto:{email}" class="hover:text-brand-500 hover:underline">{email}</a>
                                     </div>
                                 {/each}
                             {/if}


                             {#if profile.website}
                                <div class="flex items-center gap-2">
                                    <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
                                    <a href={profile.website} target="_blank" class="hover:text-brand-500 hover:underline">{profile.website.replace(/^https?:\/\//, '')}</a>
                                </div>
                             {/if}
                             <!-- <div class="flex items-center gap-2">
                                 <svg class="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
                                 <span class="hover:text-brand-500 cursor-pointer">@arthurkdev</span>
                             </div> -->

                             <!-- Social Links -->
                             {#if socialLinks.length > 0}
                                 {#each socialLinks as link}
                                     <div class="flex items-center gap-2">
                                        <svg class="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
                                            {@html getPlatformIcon(link.platform)}
                                        </svg>
                                         <a href={link.url} target="_blank" class="hover:text-brand-500 hover:underline capitalize">
                                             {link.platform === 'website' ? link.url.replace(/^https?:\/\//, '').split('/')[0] : link.platform}
                                         </a>
                                     </div>
                                 {/each}
                             {/if}

                             
                        </div>

                         <!-- Achievements Mockup -->
                        <!-- <div class="pt-4 border-t border-gray-200 dark:border-gray-800">
                             <h3 class="font-semibold mb-2">Achievements</h3>
                             <div class="flex gap-2">
                                 <img src="https://github.githubassets.com/assets/arctic-code-vault-contributor-default-df8d74b9c79d.png" class="w-10 h-10" title="Arctic Code Vault Contributor" alt="Achievement" />
                                 <img src="https://github.githubassets.com/assets/pull-shark-default-498c279a747d.png" class="w-10 h-10" title="Pull Shark" alt="Achievement" />
                                 <img src="https://github.githubassets.com/assets/quickdraw-default-39c6aec8c9d7.png" class="w-10 h-10" title="Quickdraw" alt="Achievement" />
                             </div>
                        </div> -->
                    </div>
                </aside>

                <!-- Main Content -->
                <main class="flex-1 min-w-0">
                    
                    {#if activeTab === 'overview'}
                         <!-- Pinned Repos -->
                         <div class="mb-10">
                             <div class="flex items-center justify-between mb-4">
                                 <h2 class="text-base font-semibold">Pinned</h2>
                                 {#if isCurrentUser}
                                     <button class="text-xs text-gray-500 hover:text-brand-500">Customize your pins</button>
                                 {/if}
                             </div>
                             
                             <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                 {#each pinnedRepos as repo}
                                     <div class="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 flex flex-col justify-between hover:border-gray-300 dark:hover:border-gray-600 transition-colors">
                                         <div>
                                             <div class="flex items-center gap-2 mb-2">
                                                 <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
                                                 <a href="#" class="font-semibold text-brand-500 hover:underline">{repo.name}</a>
                                                 <span class="px-2 py-0.5 text-xs border border-gray-200 dark:border-gray-600 rounded-full text-gray-500">{repo.visibility}</span>
                                             </div>
                                             <p class="text-xs text-gray-500 dark:text-gray-400 mb-4 line-clamp-2">{repo.description}</p>
                                         </div>
                                         <div class="flex items-center gap-4 text-xs text-gray-500">
                                             {#if repo.primaryLanguage}
                                                 <div class="flex items-center gap-1">
                                                     <span class="w-3 h-3 rounded-full" style="background-color: {repo.primaryLanguageColor}"></span>
                                                     {repo.primaryLanguage}
                                                 </div>
                                             {/if}
                                             <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                 <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                                 {repo.starCount}
                                             </div>
                                              <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                 <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.778 7.24a2 2 0 100 4 2 2 0 000-4z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7h.01" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2a10 10 0 100 20 10 10 0 000-20z" /></svg>
                                                 {repo.forkCount}
                                             </div>
                                         </div>
                                     </div>
                                 {/each}
                             </div>
                         </div>
                         
                         <!-- Activity Graph -->
                         <div class="mb-10">
                             <h2 class="text-base font-semibold mb-2">{totalCommits} contributions in the last year</h2>
                             <div class="p-4 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800">
                                 <ActivityGraph commitData={commitData} />
                             </div>
                         </div>
                         
                      <!-- <PublicRecentActivity /> -->
                    {:else if activeTab === 'repositories'}
                         <!-- Repo Search/Filter Bar -->
                         <div class="flex flex-col md:flex-row gap-4 mb-6 pb-6 border-b border-gray-200 dark:border-gray-800">
                             <input type="text" placeholder="Find a repository..." class="flex-1 px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" />
                             <div class="flex gap-2">
                                 <select class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-800 text-sm focus:outline-none">
                                     <option>Type</option>
                                     <option>All</option>
                                     <option>Public</option>
                                     <option>Private</option>
                                     <option>Sources</option>
                                     <option>Forks</option>
                                     <option>Archived</option>
                                     <option>Mirrors</option>
                                 </select>
                                 <select class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-800 text-sm focus:outline-none">
                                     <option>Language</option>
                                     <option>All</option>
                                     <option>Go</option>
                                     <option>TypeScript</option>
                                     <option>Svelte</option>
                                 </select>
                                 <select class="px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-800 text-sm focus:outline-none">
                                     <option>Sort</option>
                                     <option>Last updated</option>
                                     <option>Name</option>
                                     <option>Stars</option>
                                 </select>
                                 <button class="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded-md text-sm font-medium flex items-center gap-1">
                                     <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>
                                     New
                                 </button>
                             </div>
                         </div>
                         
                         <!-- Repo List -->
                         <div class="space-y-6">
                             {#each repositories as repo}
                                 <div class="flex flex-col md:flex-row justify-between items-start md:items-center py-6 border-b border-gray-200 dark:border-gray-800 last:border-0">
                                     <div class="flex-1">
                                         <div class="flex items-center gap-3 mb-2">
                                             <a href="#" class="text-xl font-bold text-brand-500 hover:underline">{repo.name}</a>
                                             <span class="px-2 py-0.5 text-xs border border-gray-200 dark:border-gray-600 rounded-full text-gray-500">{repo.visibility}</span>
                                         </div>
                                         <p class="text-gray-600 dark:text-gray-400 text-sm mb-4 max-w-2xl">{repo.description}</p>
                                         <div class="flex items-center gap-6 text-xs text-gray-500">
                                             {#if repo.primaryLanguage}
                                                 <div class="flex items-center gap-1">
                                                     <span class="w-3 h-3 rounded-full" style="background-color: {repo.primaryLanguageColor}"></span>
                                                     {repo.primaryLanguage}
                                                 </div>
                                             {/if}
                                             {#if repo.starCount > 0}
                                                 <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                     <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                                     {repo.starCount}
                                                 </div>
                                             {/if}
                                              {#if repo.forkCount > 0}
                                                 <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                     <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.778 7.24a2 2 0 100 4 2 2 0 000-4z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7h.01" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2a10 10 0 100 20 10 10 0 000-20z" /></svg>
                                                     {repo.forkCount}
                                                 </div>
                                             {/if}
                                             <span>Updated {repo.updatedAt}</span>
                                         </div>
                                     </div>
                                     <div class="mt-4 md:mt-0 flex items-center justify-end">
                                          <button class="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md text-xs font-medium flex items-center gap-1">
                                             <svg class="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                             Star
                                         </button>
                                     </div>
                                 </div>
                             {/each}
                         </div>
                    {:else if activeTab === 'stars'}
                        {#if starredLoading}
                            <div class="flex justify-center items-center h-64">
                                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
                            </div>
                        {:else if starredRepos.length === 0}
                            <div class="text-center py-20">
                                <svg class="w-16 h-16 mx-auto text-gray-400 dark:text-gray-600 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                                </svg>
                                <p class="text-gray-500 dark:text-gray-400 text-lg">{profile.username} hasn't starred any repositories yet.</p>
                            </div>
                        {:else}
                            <!-- Starred Repo List -->
                            <div class="space-y-6">
                                {#each starredRepos as repo}
                                    <div class="flex flex-col md:flex-row justify-between items-start md:items-center py-6 border-b border-gray-200 dark:border-gray-800 last:border-0">
                                        <div class="flex-1">
                                            <div class="flex items-center gap-3 mb-2">
                                                <a href="#" class="text-xl font-bold text-brand-500 hover:underline">{repo.name}</a>
                                                <span class="px-2 py-0.5 text-xs border border-gray-200 dark:border-gray-600 rounded-full text-gray-500">{repo.visibility}</span>
                                            </div>
                                            <p class="text-gray-600 dark:text-gray-400 text-sm mb-4 max-w-2xl">{repo.description}</p>
                                            <div class="flex items-center gap-6 text-xs text-gray-500">
                                                {#if repo.primaryLanguage}
                                                    <div class="flex items-center gap-1">
                                                        <span class="w-3 h-3 rounded-full" style="background-color: {repo.primaryLanguageColor}"></span>
                                                        {repo.primaryLanguage}
                                                    </div>
                                                {/if}
                                                {#if repo.starCount > 0}
                                                    <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                                        {repo.starCount}
                                                    </div>
                                                {/if}
                                                {#if repo.forkCount > 0}
                                                    <div class="flex items-center gap-1 hover:text-brand-500 cursor-pointer">
                                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.778 7.24a2 2 0 100 4 2 2 0 000-4z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7h.01" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2a10 10 0 100 20 10 10 0 000-20z" /></svg>
                                                        {repo.forkCount}
                                                    </div>
                                                {/if}
                                                {#if repo.updatedAt?.seconds}
                                                    <span>Updated {getRelativeTime(new Date(Number(repo.updatedAt.seconds) * 1000))}</span>
                                                {/if}
                                            </div>
                                        </div>
                                        <div class="mt-4 md:mt-0 flex items-center justify-end">
                                            <button class="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md text-xs font-medium flex items-center gap-1">
                                                <svg class="w-4 h-4 text-gray-500 fill-yellow-400 stroke-yellow-500" fill="currentColor" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                                                Starred
                                            </button>
                                        </div>
                                    </div>
                                {/each}
                            </div>
                        {/if}
                    {/if}
                </main>
            </div>
		{/if}
	</div>
</div>
